const manifest = {
  "name": "Background",
  "description": "Make your editor look brand new.",
  "editorOnly": true,
  "tags": [
    "astraeditor",
    "ae",
    "new"
  ],
  "info": [
    {
      "type": "notice",
      "text": "This may reduce performance.",
      "id": "reducePerformance"
    }
  ],
  "credits": [
    {
      "name": "KOSHINO",
      "link": "https://github.com/KOSHINOawa"
    },
    {
      "name": "RyaninCn11",
      "link": "https://github.com/RyaninCn11"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ]
};
export default manifest;
